import { ListCard } from "@components/styles/dataDisplay";
import { FiPaperclip } from "@react-icons/all-files/fi/FiPaperclip";

import React from "react";
import Skeleton from "react-loading-skeleton";

import { DocumentsSkeletonBody, DocumentsSkeletonContainer } from "./style";
import { useTheme } from "emotion-theming";
import { StandardTheme } from "@nectarTypes";

const DocumentCardSkeleton = () => {
  const theme = useTheme<StandardTheme>();

  return (
    <DocumentsSkeletonContainer>
      <div style={{ gridArea: "skeletonData" }} id="skeleton-data">
        <Skeleton height={16} width={88} />
      </div>
      <DocumentsSkeletonBody>
        <FiPaperclip size={16} color={theme.colors.gray500} rotate={90} />

        <div style={{ rowGap: 16, display: "flex", width: "100%", flexDirection: "column" }}>
          <Skeleton height={16} className="skeleton-title" />
          <Skeleton height={16} className="skeleton" />
          <Skeleton height={16} className="skeleton" />
        </div>
      </DocumentsSkeletonBody>
      <div style={{ gridArea: "skeletonButton" }} id="skeleton-button">
        <Skeleton height={38} />
      </div>
    </DocumentsSkeletonContainer>
  );
};

const DocumentsTabSkeleton = () => {
  return (
    <div>
      <Skeleton width={215} />
      <ListCard style={{ marginTop: 10 }} border>
        <DocumentCardSkeleton />
        <DocumentCardSkeleton />
        <DocumentCardSkeleton />
      </ListCard>
    </div>
  );
};

export default DocumentsTabSkeleton;
